export default "__VITE_ASSET__BgJ6ELxY__"